import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Select } from '../../styled-components/';
import LuciPropTypes from '../../propTypes/';

const getSelectedChannelValue = (defaultChannel, channelList) => {
  if (defaultChannel && channelList) {
    for (let i = 0; i < channelList.length; i++) {
      if (defaultChannel.toLowerCase() === channelList[i].name.toLowerCase()) {
        return channelList[i].id;
      }
    }
  }
  return -1;
};

class ChannelSelect extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      channelValue: getSelectedChannelValue(props.selectedChannel, props.channelList)
    };
  }

  UNSAFE_componentWillUpdate(nextProps) {
    this.setState({
      channelValue: getSelectedChannelValue(nextProps.selectedChannel, nextProps.channelList)
    });
  }

  render() {
    const { channelList, onChanged } = this.props;
    return (
      <Select 
        height="1.15rem"
        ref={this.props.channelInputRef} 
        value={this.state.channelValue} 
        id="channelSelect" 
        onChange={onChanged} 
      >
        {channelList.map((channel) =>
          <option key={channel.id} value={channel.id}>{channel.name}</option>)}
      </Select>
    );
  }
}

ChannelSelect.defaultProps = {
  selectedChannel: '',
  onChanged: () => {},
  channelInputRef: () => {}
};

ChannelSelect.propTypes = {
  channelList: LuciPropTypes.ChannelList.isRequired,
  selectedChannel: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChanged: PropTypes.func,
  channelInputRef: PropTypes.func
};

export default ChannelSelect;



// WEBPACK FOOTER //
// ./app/components/Editor/ChannelSelect.js